<template>
    <BuyComponent />
</template>

<script setup>
import BuyComponent from '@/components/pay/BuyComponent.vue'
</script>